import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

// Component to redirect public users to chat interface
export default function InmateSearchWidget() {
  // Remove entire inmate search function for public access
  // Redirect to the more prominent Chat Bot interface
  return (
    <>
      <Helmet>
        <title>Inmate Search - Under Construction | Sailors Bail Bonds</title>
        <meta name="description" content="Inmate search feature is currently under construction. Please contact us directly for assistance." />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Header />
        
        {/* Under Construction Section */}
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Under Construction
            </h1>
            
            <div className="bg-white rounded-lg shadow-xl p-8 mb-8">
              <img 
                src="/assets/images/pirate_ship_under_construction_fourteen_ninety_two.png"
                alt="Historical 1492-style pirate ship under construction with numerous workers building the wooden hull, scaffolding, and period-accurate shipyard setting"
                className="w-full h-auto rounded-lg mb-6"
              />
              
              <p className="text-xl text-gray-700 mb-4">
                We're building something great! Our inmate search feature is currently being enhanced to serve you better.
              </p>
              
              <p className="text-lg text-gray-600 mb-6">
                In the meantime, please feel free to contact us directly for any bail bond assistance or inmate information.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="/chat-interface" 
                  className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                >
                  Chat with Damian
                </a>
                <a 
                  href="/contact-us" 
                  className="bg-gray-200 text-gray-800 px-8 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
                >
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}